module.exports = __webpack_public_path__ + "431abd6233013126d330814cb4a3bf9b.ttf";